// Food Fool theme
// Main JavaScript entry point
import CartDrawer from './cart-drawer';
import AuthorDrawer from './author-drawer';

// Function to add a product to the cart
const addToCart = async (productId, quantity = 1) => {
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: productId,
        quantity: quantity
      })
    });
    
    if (!response.ok) {
      throw new Error('Failed to add product to cart');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error adding product to cart:', error);
    return null;
  }
};

const initApp = () => {
  console.log('Food Fool theme initialized');
  
  // Initialize cart drawer
  const cartDrawer = new CartDrawer();
  
  // Initialize author drawer
  const authorDrawer = new AuthorDrawer();
  
  // Add to cart functionality for product hero section
  const buyNowButtons = document.querySelectorAll('[data-add-to-cart]');
  
  buyNowButtons.forEach(button => {
    button.addEventListener('click', async (event) => {
      event.preventDefault();
      
      // Show loading state
      const originalText = button.textContent;
      button.textContent = 'Adding...';
      button.disabled = true;
      
      try {
        // Get variant ID from button data attribute
        const variantId = button.getAttribute('data-variant-id');
        
        if (variantId) {
          console.log('Adding variant to cart:', variantId);
          // Add product to cart
          const result = await addToCart(variantId);
          
          if (result) {
            console.log('Successfully added to cart:', result);
            
            // We'll only need one fetch - the item we just added should be in the cart
            try {
              // Get full cart data (the add.js response doesn't include all cart data)
              const cartResponse = await fetch('/cart.js');
              if (cartResponse.ok) {
                const cartData = await cartResponse.json();
                // Update cart data first
                cartDrawer.updateCartDrawer(cartData);
                // Then open the drawer
                cartDrawer.openDrawer();
                
                // Intentionally NOT calling fetchCartData() which would cause another refresh
                // We'll let the automatic secondary refresh handle any discrepancies 
                // without causing flashing
              }
            } catch (error) {
              console.error('Error getting cart data after add:', error);
              // If there was an error fetching data, try opening the drawer anyway
              cartDrawer.openDrawer();
            }
            
            // Reset button state
            button.textContent = originalText;
            button.disabled = false;
            return; // Exit early to prevent double reset
          } else {
            console.error('Failed to add to cart');
            // Show error feedback
            button.textContent = 'Error - Try Again';
            setTimeout(() => {
              button.textContent = originalText;
              button.disabled = false;
            }, 2000);
            return; // Exit early to prevent double reset
          }
        } else {
          console.error('No variant ID provided');
          // Open cart drawer anyway to show current cart
          cartDrawer.openDrawer();
        }
      } catch (error) {
        console.error('Error in add to cart flow:', error);
      }
      
      // Reset button state if we get here
      button.textContent = originalText;
      button.disabled = false;
    });
  });
  
  // Standard cart open buttons
  const cartOpenButtons = document.querySelectorAll('[data-cart-open]:not([data-add-to-cart])');
  cartOpenButtons.forEach(button => {
    button.addEventListener('click', () => {
      cartDrawer.openDrawer();
    });
  });

  // Author info buttons
  const authorButtons = document.querySelectorAll('.fiona__more');
  authorButtons.forEach(button => {
    button.addEventListener('click', () => {
      authorDrawer.openDrawer();
    });
  });
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp);
} else {
  initApp();
}